import React, { useEffect, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate } from "react-router-dom";
import { setToken, setUser } from "../redux/slices/user/userSlice";
import { getToken, getUserPref, saveUserPref } from "../uttils/UserPref";
import axios from "axios";
import { useGetOutHowQuery } from "../services/outHowAPI";
import { setWicketTypeData } from "../redux/slices/outhow/wicketTypeSlice";

const PrivateRoute = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: outHowData } = useGetOutHowQuery();
  if (outHowData) {
    dispatch(setWicketTypeData(outHowData));
  }

  console.log("Outside layout ");

  useLayoutEffect(() => {
    console.log("Inside layout ");
  }, []);
  const _navigateTo = async () => {
    let refreshToken;
    let parsedUserData;
    try {
      const token = getToken();
      if (!token) {
        navigate("/");
        return;
      }
      refreshToken = localStorage.getItem("refreshToken");
      const userData = getUserPref();
      parsedUserData = JSON.parse(userData);

      // check if token is working
      const res = await axios.get(
        `${process.env.REACT_APP_DEV_BASE_URL}/user/profile/${parsedUserData?.user?._id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Private Route", res);

      //   if (!res?.data?.success) {
      //     // refresh
      //     tokenRefresh(refreshToken!, parsedUserData);
      //     return;
      //   }

      parsedUserData = { ...parsedUserData, ...{ user: res?.data?.data } };

      dispatch(setUser(parsedUserData?.user));
      saveUserPref(parsedUserData);
      dispatch(setToken(token));
      // navigate("/user/home");
    } catch (err) {
      //   if (err?.response?.data?.message === 'Invalid token') {
      //     tokenRefresh(refreshToken!, parsedUserData);
      //   }
    }
  };

  useEffect(() => {
    _navigateTo();
  }, []);

  return <Outlet />;
};

export default PrivateRoute;
